var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"lbDatePicker\" ng-click=\"vm.closeDatePicker()\">\n<div class=\"lbDatePicker_calendar\" ng-click=\"$event.stopPropagation()\">\n<div pickadate ng-model=\"vm.date\" format=\"{{ vm.dateFormat }}\" on-date-select=\"vm.dateSelected(date)\" min-date=\"vm.settings.minDate\" max-date=\"vm.settings.maxDate\" range-from=\"vm.settings.rangeFrom\" range-to=\"vm.settings.rangeTo\">\n</div>\n<div class=\"lbDatePicker_close\">\n<button class=\"lbDatePicker_close_button\" ng-click=\"vm.closeDatePicker()\" id=\"lbDatePickerClose\">\nClose\n</button>\n</div>\n</div>\n</div>";
var id1="components/lbDatePicker/lbDatePicker.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/components/lbDatePicker/lbDatePicker.html
// module id = 1036
// module chunks = 2